import { useTranslation } from 'react-i18next';

import { ButtonLink } from '@/shared/components/Button';
import { EmptyState } from '@/shared/components/States';
import { PageHeader } from '@/shared/components/PageHeader';

/**
 * PLAT-P2-03 / NEW-A2 — an unknown address inside the supplier portal or the
 * operator console.
 *
 * Without it, `/vendor/…` and `/platform/…` fell through to the tenant `*`
 * under `RequireAuth`: a supplier or an operator who mistyped a path was shown
 * the customer's sign-in or the customer's not-found page. Rendered as the
 * shell's own catch-all, it keeps them inside the shell they were in (signed
 * out, the shell shows its own sign-in first) with one way back to its home.
 */
export function ShellNotFound({ home, homeLabelKey }: { home: string; homeLabelKey: string }) {
  const { t } = useTranslation();

  return (
    <div className="space-y-5">
      <PageHeader title={t('errors.pageNotFound')} />
      <EmptyState
        title={t('errors.pageNotFoundBody')}
        action={<ButtonLink to={home}>{t(homeLabelKey)}</ButtonLink>}
      />
    </div>
  );
}
